export default __webpack_public_path__ + "static/media/EM0030.34I-19607_-14850_0.71f502af.jpg";